/* istanbul ignore file */

const addDataLayerTrigger = (name, props) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: name,
    ...props,
  });
};

export default addDataLayerTrigger;
